"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fluxActions = require("flux-actions");

var _mapPayloadTo = _interopRequireDefault(require("../utils/mapPayloadTo"));

var _createStageForEditActionType = _interopRequireDefault(require("./createStageForEditActionType"));

var _default = function _default(_ref) {
  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      objectType = _ref.objectType;
  return (0, _fluxActions.createAction)((0, _createStageForEditActionType.default)({
    namespace: namespace,
    objectType: objectType
  }), (0, _mapPayloadTo.default)(objectType));
};

exports.default = _default;
module.exports = exports.default;